import React from "react";
import "./LocationsSection.css";
import { MapPin } from "lucide-react";

const locations = [
  "Velachery", 
  "Jafferkhanpet", 
  "Pallavaram", 
  "Thiruvanmiyur", 
  "Arumbakkam (Anna Nagar)",
  "Besant nagar",
  "Vadapalani "
];

const LocationsSection = () => {
  return (
    <section id="locations" className="locations-section">
      <div className="locations-container">
        
        <div className="locations-header fade-in-up">
          <h2 className="locations-title gold-gradient-text">Service Locations</h2>
          <p className="locations-subtitle">Available across major areas in Chennai</p>
        </div>

        <div className="locations-flex-box">
          {locations.map((loc, i) => (
            <div 
              key={loc} 
              className="location-pill fade-in-scale"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <MapPin className="location-icon" size={20} />
              <span className="location-name">{loc}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LocationsSection;